// dashboard-container.component.ts
import { Component, OnInit } from "@angular/core";

@Component({
  selector: "app-dashboard-container",
  templateUrl: "./dashboard-container.component.html",
  styleUrls: ["./dashboard.component.scss"],
})
export class DashboardContainerComponent implements OnInit {
  // Kullanıcının her iki masaüstüne yetkisi var mı kontrolü
  public isUserAuthorizedForBoth: boolean = true;

  constructor() {}

  ngOnInit() {
    // İleride session veya token kontrolünü buradan yapabilirsiniz
    this.checkUserRoles();
  }

  private checkUserRoles(): void {
    // Örnek: localStorage üzerindeki token veya kullanıcı bilgisinden rol kontrolü
    const userJson = localStorage.getItem("currentUser");
    if (userJson) {
      const user = JSON.parse(userJson);
      // Eğer sadece düz personelse 2. masaüstünü (onay ekranını) gizleyebilirsiniz
      this.isUserAuthorizedForBoth =
        user.role === "ADMIN" || user.role === "MANAGER";
    }
  }
}
